import { render, staticRenderFns } from "./EditorPropertiesCamera.vue?vue&type=template&id=c87a3614&scoped=true&"
import script from "./EditorPropertiesCamera.vue?vue&type=script&lang=js&"
export * from "./EditorPropertiesCamera.vue?vue&type=script&lang=js&"
import style0 from "./EditorPropertiesCamera.vue?vue&type=style&index=0&id=c87a3614&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87a3614",
  null
  
)

export default component.exports